import FlexBetween from './flexbox/FlexBetween';
import { useEffect } from 'react';

import { ErrorOutlineOutlined } from "@mui/icons-material";
import { Typography, Box } from "@mui/material";
import React from 'react';

const ErrorPage: React.FC = () => {
    useEffect(() => {
        if (sessionStorage.getItem(`tryReload`)) {
            return;
        }
        sessionStorage.setItem(`tryReload`, `true`);
        window.location.reload();
    }, []);
    return (
        <Box>
            <FlexBetween sx={{ padding: `30px`, flexDirection: `column` }}>
                <ErrorOutlineOutlined sx={{ fontSize: 80, color: `error.main`, mb: 2 }} />
                <Typography variant="h4" gutterBottom>
                    Oops! Something went wrong.
                </Typography>
                <Typography variant="body1" color="text.secondary" mb={3}>
                    Don&apos;t worry, we&apos;ll have it fixed soon!
                </Typography>
            </FlexBetween>
        </Box>
    );
};

export default ErrorPage;
